const LOADHR_DATA = "LOADHR_DATA";
const LOADHR_DATA_SUCCESS = "LOADHR_DATA_SUCCESS";
const LOADHR_DATA_FAIL = "LOADHR_DATA_FAIL";

const LOADHRINFO_DATA = "LOADHRINFO_DATA";
const LOADHRINFO_DATA_SUCCESS = "LOADHRINFO_DATA_SUCCESS";
const LOADHRINFO_DATA_FAIL = "LOADHRINFO_DATA_FAIL";

const LOADFISCALYEAR_DATA = "LOADFISCALYEAR_DATA";
const LOADFISCALYEAR_DATA_SUCCESS = "LOADFISCALYEAR_DATA_SUCCESS";
const LOADFISCALYEAR_DATA_FAIL = "LOADFISCALYEAR_DATA_FAIL";

const HR_POST = "HR_POST";
const HR_DELETE = "HR_DELETE";

const initialState = {
  data: [],
  dataInfo: [],
  fiscalYears: [],
  isLoading: false,
  hasError: false,
};

export default function hr(state = initialState, action) {
  switch (action.type) {
    case LOADHR_DATA: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case LOADHR_DATA_FAIL: {
      return {
        ...state,
        isLoading: false,
        hasError: true,
      };
    }

    case LOADHR_DATA_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        isLoading: false,
      };
    }
    case LOADHRINFO_DATA: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case LOADHRINFO_DATA_FAIL: {
      return {
        ...state,
        isLoading: false,
        hasError: true,
      };
    }

    case LOADHRINFO_DATA_SUCCESS: {
      return {
        ...state,
        dataInfo: action.payload.data,
        isLoading: false,
      };
    }

    case LOADFISCALYEAR_DATA: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case LOADFISCALYEAR_DATA_FAIL: {
      return {
        ...state,
        isLoading: false,
        hasError: true,
      };
    }

    case LOADFISCALYEAR_DATA_SUCCESS: {
      return {
        ...state,
        fiscalYears: action.payload.data,
        isLoading: false,
      };
    }

    default:
      return state;
  }
}

export function getHrData() {
  return {
    type: LOADHR_DATA,
    payload: {
      request: {
        baseUrl: process.env.PUBLIC_URL,
        url: "/data/hr-data.json",
      },
    },
  };
}

export function getHR() {
  return {
    type: LOADHR_DATA,
    payload: {
      request: {
        url: "HR",
      },
    },
  };
}

export function getFiscalYears() {
  return {
    type: LOADFISCALYEAR_DATA,
    payload: {
      request: {
        url: "HR/GetFiscalYears",
      },
    },
  };
}

export function getHRByFiscalYear(fiscalYear) {
  return {
    type: LOADHR_DATA,
    payload: {
      request: {
        url: `HR/GetByFiscalYear/${fiscalYear}`,
      },
    },
  };
}

export function getHRInfoById(id) {
  return {
    type: LOADHRINFO_DATA,
    payload: {
      request: {
        url: `HR/GetHrInfoById/${id}`,
      },
    },
  };
}

export function addOrEditHR(hr) {
  return {
    type: HR_POST,
    payload: {
      request: {
        url: "HR",
        method: "POST",
        data: hr,
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getHR());
        },
      },
    },
  };
}

export function addOrEditHRInfo(hrInfo, hrInfoId) {
  return {
    type: HR_POST,
    payload: {
      request: {
        url: "HR/Info",
        method: "POST",
        data: hrInfo,
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getHRInfoById(hrInfoId));
        },
      },
    },
  };
}

export function deleteHR(id) {
  return {
    type: HR_DELETE,
    payload: {
      request: {
        url: "HR/" + id,
        method: "DELETE",
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getHR());
        },
      },
    },
  };
}

export function deleteHRInfo(id, hrInfoId) {
  return {
    type: HR_DELETE,
    payload: {
      request: {
        url: "HR/Info/" + id,
        method: "DELETE",
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getHRInfoById(hrInfoId));
        },
      },
    },
  };
}
